export default __webpack_public_path__ + "static/media/JimPeters.f9da0464.pdf";